import { useState, useEffect } from "react";
import { useScramble } from "use-scramble";
import loadingSentences from "./loading-sentences.json";

export const useLoadingText = (
  isLoading: boolean,
  isMessageStreaming: boolean = false,
  isHome: boolean = false
) => {
  const [scrambleText, setScrambleText] = useState("");

  const { ref } = useScramble({
    text: scrambleText,
    range: [65, 125],
    speed: 1,
    tick: 3,
    step: 4,
    scramble: 10,
    seed: 10,
    chance: 0.12,
    overdrive: true,
    overflow: true,
  });

  useEffect(() => {
    let intervalId: NodeJS.Timeout;
    let currentIndex = 0;
    try {
      if ((isLoading || isMessageStreaming) && !isHome) {
        // Start with a random index
        currentIndex = Math.floor(
          Math.random() * loadingSentences?.loadingSentences?.length
        );
        setScrambleText(loadingSentences?.loadingSentences[currentIndex]);

        intervalId = setInterval(() => {
          currentIndex =
            (currentIndex + 1) % loadingSentences?.loadingSentences?.length;
          setScrambleText(loadingSentences?.loadingSentences[currentIndex]);
        }, 15000);
      } else {
        setScrambleText("");
      }

      return () => {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };
    } catch (error) {
      console.error("Error setting scramble text:", error);
    }
  }, [isLoading, isMessageStreaming, isHome]);

  return {
    ref,
    isVisible:
      (isLoading || isMessageStreaming) && !isHome && scrambleText !== "",
  };
};
